var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "card" },
    [
      _c(
        "header",
        {
          staticClass: "card-header",
          on: {
            click: function ($event) {
              return _vm.$emit("expand", _vm.name)
            },
          },
        },
        [
          _c("p", { staticClass: "card-header-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "card-header-icon",
              attrs: { "aria-label": "more options" },
            },
            [
              _c(
                "span",
                { staticClass: "icon", class: { rotate: _vm.isExpanded } },
                [
                  _c("i", {
                    staticClass: "fas fa-angle-down",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("transition-height", { attrs: { duration: 500, appear: "" } }, [
        _vm.isExpanded
          ? _c("div", { staticClass: "card-content" }, [
              _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }